import { gql } from '@zenbusiness/application-commons-graphql';

// Define query get institution
export const INSTITUTION_QUERY = gql`
  query institution($params: RoutingNumberInput!) {
    institution(params: $params) {
      name
      isWireSupported
      isACHSupported
    }
  }
`;
